import React, { useState } from 'react';
import './FocusToggle.css';

const KEY = 'nc-wq-focus';

// Focus mode on or off, remembered on this computer. Used by Gennemgang, Konfiguration and Compliance.
export function useFocusMode() {
  const [on, setOn] = useState(() => { try { return localStorage.getItem(KEY) !== 'off'; } catch { return true; } });
  const toggle = () => setOn((v) => { const next = !v; try { localStorage.setItem(KEY, next ? 'on' : 'off'); } catch { /* not remembered */ } return next; });
  return [on, toggle];
}

const EYE = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></svg>;
const EYE_OFF = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 3l18 18" /><path d="M10.6 6.2A9.8 9.8 0 0112 5c6.5 0 10 7 10 7a17 17 0 01-3.1 4.1M6.5 7.5C3.7 9.2 2 12 2 12s3.5 7 10 7a9.6 9.6 0 004-.9" /><path d="M9.9 10a3 3 0 004.1 4.1" /></svg>;

// The "Focus mode" button: an eye, the name and a small switch. While it is on, the page's big heading steps back (see FocusToggle.css).
export default function FocusToggle({ on, onToggle, disabled, disabledTitle }) {
  const title = disabled ? disabledTitle : on ? 'Focus mode er til. Tryk for at slå det fra' : 'Focus mode er fra. Tryk for at slå det til';
  return (
    <button type="button" className={`wq-focus fz${on ? ' is-on' : ''}`} aria-pressed={on} disabled={disabled} onClick={onToggle} title={title}>
      {on ? EYE : EYE_OFF}
      <span>Focus mode</span>
      <span className="fz__sw" aria-hidden="true" />
    </button>
  );
}
